/**
 * @author HungNS
 */
import BaseService from "./BaseService";
import {ROOT, PROFILE} from "./_base";

class ProfileService extends BaseService {

    async getAmsCustomerInfo(activeMasking) {
        const response = await this.getByUri(`${ROOT}/${PROFILE}/get-ams-customer-info?active-masking=${activeMasking}`);
        return response.data;
    }

    async saveAmsCustomerDetail(data) {
        const response = await this.post(`${ROOT}/${PROFILE}/save-ams-customer-detail`, data);
        return response.data;
    }

    async activePostDoc(data) {
        const response = await this.post(`${ROOT}/${PROFILE}/active-post-doc`, data);
        return response.data;
    }

    async uploadMyNumber(data) {
        const response = await this.post(`${ROOT}/${PROFILE}/save-mn-upload-file`, data);
        return response;
    }

    async uploadIdDocumentFile(data) {
        const response = await this.post(`${ROOT}/${PROFILE}/save-id-document-file`, data);
        return response;
    }

    async confirmMail(token) {
        const response = await this.getByUri(`${ROOT}/${PROFILE}/confirm-mail?token=` + token);
        return response.data;
    }
}
export default ProfileService;
